import React, { useEffect, useState } from "react";
import Preloader from "../Components/Preloader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import {
  FaMoneyBillWave,
  FaTicketAlt,
  FaBullhorn,
  FaCheckCircle,
  FaPlusCircle,
  FaGift,
  FaShieldAlt,
} from "react-icons/fa";
import AOS from "aos";
import { NavLink } from "react-router-dom";

function OfferPage() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 750,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  // Icon style for list icons
  const iconStyle = { marginRight: "8px", color: "#f8f9fa" /* white */ };

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Header />
          {/* Start Banner Area */}
          <div className="banner-area bg-color-theme position-relative overflow-hidden">
            <div className="container">
              <div className="banner-content" data-aos="zoom-in-up"
                data-aos-delay={500}>
                <h1 className="text-white">Happy Holidays Raffle!</h1>
                <h3 style={{color:'#eba12a'}}>Send More, Celebrate More, Win Big!</h3>
                <p className="mb-1" style={{color:'#ffd38b'}}>
                  This holiday season, IfePay is giving you even more reasons to send love back home.
                </p>
                <p className="mb-1" style={{color:'#ffd38b'}}>
                  Make a transfer and enter our <strong>exclusive festive raffle</strong> with amazing prizes!
                </p>
              </div>
            </div>
            <div className="shape-image">
              <img
                className="hero-shape-1 moveHorizontal_reverse"
                src="assets/images/offer/gift-box.png"
                alt="image"
                data-aos="zoom-in-up" data-aos-delay={500}
              />
              <img
                className="hero-shape-2 moveHorizontal_reverse"
                src="assets/images/offer/gift-box.png"
                alt="image"
                data-aos="zoom-in-up" data-aos-delay={500}
              />
            </div>
          </div>
          {/* End Banner Area */}
          {/* Start Revenue Area */}
          <div className="revenue-area pb-120 bg-color-theme overflow-hidden">
            <div className="container-fluid side-padding">
              <div className="row g-4 justify-content-center" data-aos="zoom-in-up"
                data-aos-delay={800}>
                <div className="col-lg-5 col-md-5">
                  <div className="radius-30 p-4 text-center" style={{border:'4px dotted #ffd38b'}}>
                    <h3 className="mb-3" style={{color:'#eba12a'}}>Prize 1: Amazon Alexa (5 Winners!)</h3>
                    <p className="text-white">
                      Send <strong>£500 or more</strong> using IfePay and automatically enter the draw to<br /><strong>WIN an Amazon Alexa</strong>.
                    </p>
                    <p className="text-white">
                      Five lucky winners will receive this smart home favourite - perfect for music, reminders, news, and your daily life.
                    </p>
                    <h4 style={{color:'#eba12a'}}>More you send = More entries!</h4>
                    <img
                      className="app-image-4"
                      src="assets/images/offer/alex_img.png"
                      alt="Prize 1: Amazon Alexa (5 Winners!)"
                    />
                  </div>
                </div>
                <div className="col-lg-5 col-md-5">
                  <div className="radius-30 p-4 text-center" style={{border:'4px dotted #ffd38b'}}>
                    <h3 className="mb-3" style={{color:'#eba12a'}}>Grand Prize: 75-Inch TV (1 Winner!)</h3>
                    <p className="text-white">
                      Send <strong>£1,000 or more</strong> and you’ll enter our grand prize draw to<br /><strong>WIN a stunning 75-inch television</strong>.
                    </p>
                    <p className="text-white">
                      A true home-cinema upgrade - one winner takes it home!<br /><span style={{ visibility: "hidden" }}>lodsffsfgfgdfgf fsdfsfgsd dfsdf asfsf</span>
                    </p>
                    <h4 style={{color:'#eba12a'}}>Every qualifying transfer counts as one entry.</h4>
                    <img
                      className="app-image-4"
                      src="assets/images/offer/led_img.png"
                      alt="Grand Prize: 75-Inch TV (1 Winner!)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Revenue Area */}
          {/* Start Features Area */}
          <div className="features-area ptb-120">
            <div className="container">
              <div className="section-title">
                <span className="sub-title">Simple, Fast, Rewarding</span>
                <h2>How It Works</h2>
              </div>

              <div className="row g-4" data-aos="zoom-in-up" data-aos-delay={800}>
                {/* Step 1 – Send Money */}
                <div className="col-lg-4 col-md-6">
                  <div className="single-account bg-color-fffaeb radius-30">
                    <div className="consumer-icon position-relative">
                      <img src="assets/images/offer/step1.png" />
                      <div className="number" style={{ color: '#fff' }}>01</div>
                    </div>
                    <p>
                      <strong>Send money using IfePay</strong> – £500+ or £1,000+.
                    </p>
                  </div>
                </div>
                {/* Step 2 – Automatic Entry */}
                <div className="col-lg-4 col-md-6">
                  <div className="single-account bg-color-fffaeb radius-30">
                    <div className="consumer-icon position-relative">
                      <img src="assets/images/offer/step2.png" />
                      <div className="number" style={{ color: '#fff' }}>02</div>
                    </div>
                    <p>
                      <strong>You’re automatically entered</strong> into the prize draw.
                    </p>
                  </div>
                </div>
                {/* Step 3 – Winner Announcement */}
                <div className="col-lg-4 col-md-6">
                  <div className="single-account bg-color-fffaeb radius-30">
                    <div className="consumer-icon position-relative">
                      <img src="assets/images/offer/step3.png" />
                      <div className="number" style={{ color: '#fff' }}>03</div>
                    </div>
                    <p>
                      <strong>Winners announced after the promotion period</strong> via email & social.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Features Area */}
          {/* Start Financial About Area */}
          <div className="financial-about-area pb-120 overflow-hidden">
            <div className="container">
              <div className="row align-items-center">
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up" data-aos-delay={800}
                >
                  <div className="about-image position-relative">
                    <img className="radius-30" src="assets/images/offer/offer.png" alt="image" />
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up" data-aos-delay={800}
                >
                  <div className="financial-about-content">
                    <div className="section-heading">
                      <span className="sub-title">Why Raffle?</span>
                      <h2>Why You’ll Love This Raffle?</h2>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <ul className="check">
                          <li>
                            <i className="ri-check-line" style={{ color: "#fff" }} />
                            No extra steps — just send as usual.
                          </li>
                          <li>
                            <i className="ri-check-line" style={{ color: "#fff" }} />
                            Every qualifying transaction increases your chances.
                          </li>
                          <li>
                            <i className="ri-check-line" style={{ color: "#fff" }} />
                            Amazing prizes perfect for the holiday season.
                          </li>
                          <li>
                            <i className="ri-check-line" style={{ color: "#fff" }} />
                            Trusted, fast, secure transfers with great rates.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up" data-aos-delay={800}
                >
                  <div className="financial-about-content">
                    <h3 className="mt-5">Promotion Validity</h3>
                    <p>
                      The Happy Holidays Raffle runs from <strong>1<sup>st</sup> December to 31<sup>st</sup> December 2025</strong>.
                      Don’t miss your chance to win big while sending money home with IfePay.
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up" data-aos-delay={800}
                >
                  <div className="financial-about-content">
                    <h3 className="mt-5">Ready to Send & Win?</h3>
                    <p>
                      Send money now and enter the raffle automatically.
                      Your transfer could turn into a prize this holiday season!
                    </p>
                    <NavLink to="/download-ifepay-app" className="default-btn mt-2">
                      Send Money Now <i className="ri-arrow-right-up-line" />
                    </NavLink>
                    {/* <NavLink to="https://ifepay.co.uk/app/app-login" target="_blank" className="default-btn mt-2">
                      Send Money Now <i className="ri-arrow-right-up-line" />
                    </NavLink> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Financial About Area */}
          <Footer />
        </>
      )}
    </>
  );
}

export default OfferPage;
